import { iconFinCartao, iconDoc2aVia, iconFinGrafico } from '@bsds-lib-component/icons/icons';
import React, { useId, useMemo } from 'react';

import { Tab, type TabItem } from '../../components';

import DigitalInvoincingTab from './tabs/DigitalInvoincingTab';
import DownloadAdhesionTab from './tabs/DownloadAdhesionTab';
import SearchParticipantsTab from './tabs/SearchParticipantsTab';


const PrevidenciaPage: React.FC = () => {
  const mainContentId = useId();

  const tabs: TabItem[] = useMemo(
    () => [
      {
        id: 'pesquisa-participantes',
        title: 'Pesquisa de Participantes',
        icon: iconFinCartao,
        content: <SearchParticipantsTab />,
      },
      {
        id: 'download-adesoes',
        title: 'Download de Adesões',
        icon: iconDoc2aVia,
        content: <DownloadAdhesionTab />,
      },
      {
        id: 'faturamento-digital',
        title: 'Faturamento Digital',
        icon: iconFinGrafico,
        content: <DigitalInvoincingTab />,
      },
    ],
    []
  );

  return (
    <div
      className="bsds-width-100"
      role="main"
      aria-label="Página de Previdência"
      id={mainContentId}
    >
      <div className="bsds-display-flex bsds-align-items-center">
        <div className="w-[2.5px] h-8  bg-red-600 bsds-mr-12" aria-hidden="true" />
        <h2 className="opacity-80">Previdência</h2>
      </div>
      <Tab tabs={tabs} defaultTabId="pesquisa-participantes" className="bsds-mt-12" />
    </div>
  );
};

export default PrevidenciaPage;
